import React from 'react';
import styled from 'styled-components';

import { FireForecastIcon } from './fireForecastIcon';

const fireRatingColors = [
    '#6C9E26',
    '#FFDC00',
    '#FFA200',
    '#FF5B00',
    '#C42427'
];

interface FireForecastItemType {
    dayOfWeekAbbreviatedLocal: string;
    fireRiskIndex: number;
    fireRiskDescriptionShort: string;
}

export const FireForecastItem = ({ 
    dayOfWeekAbbreviatedLocal,
    fireRiskIndex,
    fireRiskDescriptionShort
 }: FireForecastItemType) => {
    return (
        <Container>
            <DaySpan>{dayOfWeekAbbreviatedLocal}</DaySpan>
            <FireForecastIcon color={fireRatingColors[fireRiskIndex - 1]} />
            <RatingSpan>{fireRiskDescriptionShort}</RatingSpan>
        </Container>
    );
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding-left: 8px;
    padding-right: 8px;
    text-align: center;
    align-items: center;
`;

const DaySpan = styled.span`
    font-size: 16px;
    font-weight: 300;
    padding=bottom: 6px;
`;

const RatingSpan = styled.span`
    font-size: 13px;
    font-weight: 200;
    padding-top: 6px;
`;
